<template>
  <admin-wrapper
    title-translation-path="navbar.zdmLightingControl"
    :has-buttons="false"
    :moduleEnabler="moduleEnabler"
  />
</template>
<script>
import AdminWrapper from '@/components/AdminWrapper';
export default {
  name: 'ZDMLightingControl',
  components: {
    AdminWrapper,
  },
  computed: {
    moduleEnabler() {
      return {
        name: 'lighting_control_module_enabled',
        translationPath: 'admin.lightingControlModule',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.lightingControlModule') }),
      };
    },
  },
};
</script>
